import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { usePageMeta } from '@/lib/usePageMeta';

export default function RefundPolicy() {
  usePageMeta({
    title: 'Refund Policy | Toia Wallace',
    description:
      'Refund policy for products, software, digital resources, educational materials, and memberships purchased through Toia Wallace and her ventures.',
    path: '/refund-policy',
    robots: 'noindex, follow',
  });

  return (
    <div className="bg-ivory">
      <section className="pt-40 lg:pt-56 pb-16 lg:pb-24">
        <div className="mx-auto max-w-[1100px] px-6 sm:px-10 lg:px-16">
          <div className="eyebrow text-taupe mb-8">Legal · Refund Policy</div>
          <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tightest text-matte">
            Refund
            <br />
            <em className="italic text-taupe">policy.</em>
          </h1>
          <p className="mt-10 font-label text-[10px] tracking-[0.28em] uppercase text-taupe">
            Effective for all products and services purchased through Toia Wallace and her ventures.
          </p>
        </div>
      </section>

      <section className="pb-24 lg:pb-40">
        <div className="mx-auto max-w-[820px] px-6 sm:px-10">
          <div className="hairline-gold h-px w-16 mb-12" aria-hidden />

          <p className="font-serif-display text-2xl md:text-3xl leading-[1.5] text-matte tracking-tight">
            Because all products, software, digital resources, educational materials, and
            memberships provide immediate access upon purchase, all sales are final.
          </p>

          <p className="mt-10 font-serif-display italic text-3xl md:text-4xl text-gold leading-tight">
            No refunds will be issued.
          </p>

          <div className="mt-16 space-y-8 text-matte/75 leading-[1.9] text-[15px]">
            <p>
              This policy applies to every purchase across the ecosystem, including but not
              limited to: LabFounders HQ, Altura Global RE, Move MODE, Between Us Convos,
              digital products, courses, memberships, and any other product or educational
              offering provided by Toia Wallace or her affiliated companies.
            </p>
            <p>
              By completing a purchase, you acknowledge and agree to this policy. If you have a
              question about a specific purchase, please reach out and the studio will respond
              directly.
            </p>
          </div>

          <div className="mt-16 flex flex-wrap gap-4">
            <Link to="/contact" className="btn-primary" data-testid="refund-cta-contact">
              Contact the Studio
              <ArrowRight size={14} strokeWidth={1.6} />
            </Link>
            <Link to="/" className="btn-ghost">
              Return Home
              <ArrowRight size={14} strokeWidth={1.6} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
